import React from 'react'
import { Container, ContainerInterno, TituloPrincipal, BoxConteudo, BoxConteudoTextos, BoxConteudoTextosTitulo, BoxConteudoTextosSubtitulo, BoxConteudoTextosTexto, BoxConteudoFigure, BoxConteudoFigureImg } from './Styled'
import mesesGratis from 'images/promocao-janeiro-2026/meses-gratis.png'
import bonusCoaching from 'images/promocao-janeiro-2026/bonus-coaching.png'

export default function BonusExclusivos ({ lote }) {

	const textoTitulo = (lote) => {
		switch (lote) {
			case 1:
				return "Bônus Exclusivos do Lote Relâmpago!"
			case 2:
				return "Bônus Exclusivos do Lote Especial!"
			case 3:
				return "Bônus Exclusivos do Lote 1!"
			case 4:
				return "Bônus Exclusivos do Último Lote!"
			default:
				return ""
		}
	}

	return (
		<Container>
			<ContainerInterno>

				{/* Título Principal */}
				<TituloPrincipal>{textoTitulo(lote)}</TituloPrincipal>

				{/* Acesso Grátis */}
				<BoxConteudo>

					{/* Texto Lote relâmpago e especial */}
					{ lote === 1 || lote === 2 ?
					<BoxConteudoTextos>
						<BoxConteudoTextosTitulo>3 a 9 meses de acesso grátis</BoxConteudoTextosTitulo>
						<BoxConteudoTextosSubtitulo>Não tem mistério:</BoxConteudoTextosSubtitulo>
						<BoxConteudoTextosTexto>👉Assinou a Básica por 12 meses: leva + 3 meses</BoxConteudoTextosTexto>
						<BoxConteudoTextosTexto margin>👉Assinou a Básica por 24 meses: leva + 6 meses</BoxConteudoTextosTexto>
						<BoxConteudoTextosTexto>👉Assinou a Premium por 12 meses: leva + 6 meses</BoxConteudoTextosTexto>
						<BoxConteudoTextosTexto margin>👉Assinou a Premium por 24 meses: leva + 9 meses</BoxConteudoTextosTexto>
						<BoxConteudoTextosTexto>Até 9 meses a mais de preparação!</BoxConteudoTextosTexto>
						<BoxConteudoTextosTexto margin>Até 9 meses a mais para ser aprovado!</BoxConteudoTextosTexto>
						<BoxConteudoTextosTexto>E sem pagar absolutamente nada!</BoxConteudoTextosTexto>
					</BoxConteudoTextos> : null }

					{/* Texto Lote 1 */}
					{ lote === 3 ?
					<BoxConteudoTextos>
						<BoxConteudoTextosTitulo>6 meses de acesso grátis</BoxConteudoTextosTitulo>
						<BoxConteudoTextosSubtitulo>Não tem mistério:</BoxConteudoTextosSubtitulo>
						<BoxConteudoTextosTexto>👉Assinou a Premium por 12 meses: leva 18 meses</BoxConteudoTextosTexto>
						<BoxConteudoTextosTexto margin>👉Assinou a Premium por 24 meses: leva 30 meses</BoxConteudoTextosTexto>
						<BoxConteudoTextosTexto>6 meses a mais de preparação!</BoxConteudoTextosTexto>
						<BoxConteudoTextosTexto margin>6 meses a mais para ser aprovado!</BoxConteudoTextosTexto>
						<BoxConteudoTextosTexto>E sem pagar absolutamente nada!</BoxConteudoTextosTexto>
					</BoxConteudoTextos> : null }

					<BoxConteudoFigure>
						<BoxConteudoFigureImg src={mesesGratis} />
					</BoxConteudoFigure>

				</BoxConteudo>

				{/* Bônus Coaching */}
				{ lote === 1 || lote === 2 ?
					<BoxConteudo>

						<BoxConteudoFigure>
							<BoxConteudoFigureImg src={bonusCoaching} />
						</BoxConteudoFigure>

						<BoxConteudoTextos padding>
							<BoxConteudoTextosTitulo>Até 2 meses de coaching grátis!</BoxConteudoTextosTitulo>
							<BoxConteudoTextosSubtitulo>NÃO PERCA TEMPO NA PREPARAÇÃO!</BoxConteudoTextosSubtitulo>
							<BoxConteudoTextosTexto>Nossos coaches, especialistas e aprovados em diversos concursos, irão ajudar você a montar seu planejamento e te colocar no caminho da aprovação muito mais rápido!</BoxConteudoTextosTexto>
						</BoxConteudoTextos>

					</BoxConteudo> : null }

			</ContainerInterno>
		</Container>
	)
}
